import { FormattedMessage } from "react-intl";
import MainView from "views/MainView";
import { _H5Event, handleFromAppParams,publicPath } from "request";
import { useEffect } from "react";
import { useIntlContext, SupportedLocales } from "views/IntlContext";

export const GoogleHome = () => {
  const { switchLanguage } = useIntlContext();

  let locale = SupportedLocales.English;

  useEffect(() => {
    const datas = {
      event: "GetTokenAndLanguage",
      pageName: "alexa",
      callback: (responseStr: any) => {
        const jsonData = handleFromAppParams(responseStr);
        switchLanguage?.(jsonData.lang);
         if (jsonData.lang === SupportedLocales.Chinese) {
           locale = SupportedLocales.Chinese;
         }
      },
    };
    _H5Event(datas);
  }, []);

  return (
    <MainView backgroundClassName="bg-page dark:bg-black1b1f1e">
      <div className="pt-5 pr-9 pb-[80px] pl-6 ">
        <div className="flex items-center justify-center flex-col">
          <img
            src={`${publicPath}/icons/ic_googlehome.png`}
            alt=""
            className="w-[54px] h-[54px] my-6"
          />
          <p className="font-semibold text-lg">
            <FormattedMessage id="helpCenter.googleHome.title" />
          </p>
        </div>
        <p className="mt-4 break-words">
          <FormattedMessage id="helpCenter.googleHome.content1" />
        </p>
        <img
          src={`${publicPath}/images/helpCenter/${locale}/googlehome/img_step01.png`}
          alt=""
          className="w-full max-w-[250px] md:max-w-[340px] rounded-md border border-solid border-gray-200 mt-6 "
        />
        <img
          src={`${publicPath}/images/helpCenter/${locale}/googlehome/img_step02.png`}
          alt=""
          className="w-full max-w-[250px] md:max-w-[340px] rounded-md border border-solid border-gray-200 mt-6 "
        />
        <p className="mt-10">
          <FormattedMessage id="helpCenter.googleHome.content2" />
        </p>
        <img
          src={`${publicPath}/images/helpCenter/${locale}/googlehome/img_step03.png`}
          alt=""
          className="w-full max-w-[250px] md:max-w-[340px] rounded-md border border-solid border-gray-200 mt-6 "
        />
        <img
          src={`${publicPath}/images/helpCenter/${locale}/googlehome/img_step04.png`}
          alt=""
          className="w-full max-w-[250px] md:max-w-[340px] rounded-md border border-solid border-gray-200 mt-6 "
        />
        <p className="mt-10">
          <FormattedMessage id="helpCenter.googleHome.content3" />
        </p>
        <img
          src={`${publicPath}/images/helpCenter/${locale}/googlehome/img_step05.png`}
          alt=""
          className="w-full max-w-[250px] md:max-w-[340px] rounded-md border border-solid border-gray-200 mt-6 "
        />

        <p className="mt-10">
          <FormattedMessage id="helpCenter.googleHome.content4" />
        </p>
      </div>
    </MainView>
  );
};
